"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryInitiatorBuilderImpl = void 0;
var remote_servers_1 = require("./../../../features/remote-servers");
var remote_server_definition_1 = require("./../../services/remote-servers/remote-server-definition");
var secondary_builder_1 = require("./secondary-builder");
/**
 * Implementation of {@link SecondaryInitiatorBuilder}.
 *
 * @since 6.9
 */
var SecondaryInitiatorBuilderImpl = /** @class */ (function (_super) {
    __extends(SecondaryInitiatorBuilderImpl, _super);
    /**
     * Constructor.
     */
    function SecondaryInitiatorBuilderImpl(topicSelectors) {
        return _super.call(this, remote_servers_1.RemoteServerType.SECONDARY_INITIATOR, topicSelectors) || this;
    }
    SecondaryInitiatorBuilderImpl.prototype.build = function (name, url) {
        return remote_server_definition_1.RemoteServerDefinitionImpl.createSecondaryDefinition(remote_servers_1.RemoteServerType.SECONDARY_INITIATOR, SecondaryInitiatorBuilderImpl.validateName(name), this.validateUrl(url), this.getPrincipal(), this.getConnectionOptions(), this.getMissingTopicNotificationFilter(), this.getCredentials());
    };
    return SecondaryInitiatorBuilderImpl;
}(secondary_builder_1.SecondaryBuilderImpl));
exports.SecondaryInitiatorBuilderImpl = SecondaryInitiatorBuilderImpl;
